import React from 'react'
import PropTypes from 'prop-types'

import S from './Link.styled'
import { useEnvDomain } from '../../../../hooks'
import { isObj, getLocalizedUrl } from '../../../../utils'
import { useSessionContext } from '../../../../api/crapi/SessionContext'
import ConsentLink from './ConsentLink'
import UpsellLink from './UpsellLink'
import AnchorLink from './AnchorLink'
import SsoLink from './SsoLink'
import { useFooterContext } from '../../FooterContext'
import languages from '../../../../../languages'

const Link = ({
  text,
  icon,
  url,
  isCrUrl = false,
  isLocalized = false,
  targetBlank = false,
  intlText,
  isDisplayed = true,
  showForLang,
  showForCountry,
  id,
  iconPosition = 'before',
  type,
  linkComponent,
  eventTitle,
  showFrGenderEqualityLink = false,
  ...rest
}) => {
  const { lang } = useFooterContext()
  const domain = useEnvDomain()
  const blank = targetBlank ? targetBlank : false
  const intlFooter =
    lang && languages[lang] ? languages[lang].footer : languages.en.footer

  const { opensInNewTab: blankIntlText } = intlFooter
  const openInNewTab = targetBlank ? blankIntlText : ''

  const intlUrl = isObj(intlText) && intlText.url ? intlText.url : url || ''
  const localizedUrl = isLocalized ? getLocalizedUrl(intlUrl, lang) : intlUrl
  const to = isCrUrl ? `${domain}${localizedUrl}` : intlUrl
  const intlTitle = isObj(intlText) && intlText.text ? intlText.text : intlText
  const intlAriaLabel = isObj(intlText) && intlText.ariaLabel
  const ariaLabelWithOpenInNewTab = `${intlAriaLabel || text}${openInNewTab}`

  const session = useSessionContext()
  const countryCode = session ? session.countryCode : ''

  const linkLang = showForLang === undefined ? lang : showForLang
  const linkGeo = showForCountry === undefined ? countryCode : showForCountry

  const linksProps = {
    to,
    blank,
    icon,
    iconPosition,
    id,
    linkComponent,
    eventTitle,
    ariaLabel: ariaLabelWithOpenInNewTab,
  }

  if (!isDisplayed || linkLang !== lang || linkGeo !== countryCode) return null
  if (id === 'frgei' && !showFrGenderEqualityLink) return null

  if (id === 'consent') return <ConsentLink text={intlTitle || text} />

  if (type === 'upsell')
    return <UpsellLink {...linksProps} intlText={intlText} {...rest} />

  if (type === 'sso')
    return <SsoLink {...linksProps} text={intlTitle || text} {...rest} />

  return (
    <S.Link>
      {url ? (
        <AnchorLink {...linksProps} text={intlTitle || text} />
      ) : (
        <span>{intlTitle || text}</span>
      )}
    </S.Link>
  )
}

Link.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
  isCrUrl: PropTypes.bool,
  isLocalized: PropTypes.bool,
  targetBlank: PropTypes.bool,
  intlText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.string,
  isDisplayed: PropTypes.bool,
  showForLang: PropTypes.string,
  showForCountry: PropTypes.string,
  id: PropTypes.string.isRequired,
  iconPosition: PropTypes.string,
  type: PropTypes.string,
  eventTitle: PropTypes.string,
}

export default Link
